import { Typography } from 'antd';
import classes from './style.module.scss';

const { Text } = Typography;

export const TableCellText = ({ text, className, style }) => (
    <Text className={className ? className : classes['table-cell-text']} style={style}>
        {text}
    </Text>
);
